import { apiGenerator } from '../../../framework/apis/apiGenerator';
import { env } from '../../../framework/utils/EnvUtils';
import { ExpenseGetResult } from '../../models/gen/expenseGetResult';
import { ExpenseSearchParam } from '../../models/gen/expenseSearchParam';
import { ExpenseSearchResult } from '../../models/gen/expenseSearchResult';
import { IdParam } from '../../models/gen/idParam';
import {
  useGenericMutation,
  useGenericQuery,
} from '../../utils/ReactQueryUtils';
import { queryOptions } from './base';

export const EXPENSE_CONTEXT_NAMES = {
  POST_EXPENSE: 'saveExpense',
  GET_EXPENSE: 'getExpense',
  DELETE_EXPENSE: 'deleteExpense',
  POST_EXPENSE_SEARCH: 'searchExpense',
} as const;

const apis = apiGenerator();

/**
 * POST `/expense`
 *
 * @param param -
 * @returns
 */
export const usePostExpense = () =>
  useGenericMutation(async (param: FormData) =>
    apis.post(`${env.BASE_API_ENDPOINT}/expense`, {
      ...queryOptions,
      data: param,
    })
  );

/**
 * GET `/expense/{id}`
 *
 * @param param -
 * @returns
 */
export const useGetExpense = (param: IdParam) =>
  useGenericQuery(
    [EXPENSE_CONTEXT_NAMES.GET_EXPENSE, param as Record<string, unknown>],
    async (_param) =>
      apis.get<void, ExpenseGetResult>(
        `${env.BASE_API_ENDPOINT}/expense/${param.id}`,
        { ...queryOptions }
      ),
    {
      enabled: false,
    }
  );

/**
 * DELETE `/expense/{id}`
 *
 * @param param -
 * @returns
 */
export const useDeleteExpense = () =>
  useGenericMutation(async (param: IdParam) =>
    apis.delete(`${env.BASE_API_ENDPOINT}/expense/${param.id}`, {
      ...queryOptions,
    })
  );

/**
 * POST `/expense/search`
 *
 * @param param -
 * @returns
 */
export const usePostExpenseSearch = (param: ExpenseSearchParam) =>
  useGenericQuery(
    [
      EXPENSE_CONTEXT_NAMES.POST_EXPENSE_SEARCH,
      param as Record<string, unknown>,
    ],
    async (_param) =>
      apis.post<ExpenseSearchParam, ExpenseSearchResult>(
        `${env.BASE_API_ENDPOINT}/expense/search`,
        { ...queryOptions, data: param }
      ),
    { enabled: false }
  );
